import GroupIcon from '@material-ui/icons/Group';
import StorageIcon from '@material-ui/icons/Storage';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import LockIcon from '@material-ui/icons/Lock';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import MailIcon from '@material-ui/icons/Mail';
import ListAltIcon from '@material-ui/icons/ListAlt';

export default [
  {
    title: '',
    pages: [
      {
        title: 'Groups',
        href: '/groups',
        icon: GroupIcon
      },
      {
        title: 'Repositories',
        href: '/repositories',
        icon: StorageIcon
      },
      {
        title: 'Admin',
        icon: LockIcon,
        children: [
          {
            title: 'Public Repository',
            href: '/public-repositories',
            icon: StorageIcon
          },
          {
            title: 'Users',
            href: '/users',
            icon: AccountCircleIcon
          },
          {
            title: 'Inclusive Access',
            href: '/inclusive-access',
            icon: MenuBookIcon
          },
          {
            title: 'Faculty Approvals',
            href: '/approvals',
            icon: ThumbUpIcon
          },
          {
            title: 'Access Codes',
            href: '/access-codes',
            icon: VpnKeyIcon
          },
          {
            title: 'Register',
            href: '/register',
            icon: PersonAddIcon
          },
          {
            title: 'Mail',
            href: '/mail',
            icon: MailIcon
          },
          {
            title: 'Mail Queue',
            href: '/mail-queue',
            icon: ListAltIcon
          }
        ]
      }
    ]
  }
];
